import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgExpand = props => _jsx("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), {}, {
  children: _jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [_jsx("rect", {
      fill: props.color || "#333",
      opacity: 0.75,
      style: {
        mixBlendMode: "multiply"
      },
      width: 32,
      height: 32,
      rx: 4
    }), _jsx("path", {
      d: "M4 4h24v24H4z"
    }), _jsx("path", {
      fill: "#FFF",
      fillRule: "nonzero",
      d: "M24 15.111V8h-7.111l2.924 2.924-8.889 8.889L8 16.889V24h7.111l-2.924-2.924 8.889-8.889z"
    })]
  })
}));
export default SvgExpand;